module.exports = __webpack_public_path__ + "media/b_bppair_win.af896fdf.mp3";